import { paidApiLimitMessage } from '../utils/paidApiLimit.js'

function detailFrom(error) {
  const detail = error?.response?.data?.detail ?? error?.detail
  if (typeof detail === 'string' && detail.trim()) return detail.trim()
  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || item?.message || '')
      .filter(Boolean)
      .join(' ')
  }
  if (detail && typeof detail === 'object') {
    return String(detail.message || detail.msg || '').trim()
  }
  return ''
}

export function describeIdentifyImageError(error) {
  const limited = paidApiLimitMessage(error)
  if (limited) return limited
  const status = Number(error?.response?.status ?? error?.status ?? 0)
  const detail = detailFrom(error)
  if (status === 400) return detail || 'Image ou requête invalide.'
  if (status === 401 || status === 403) return detail || 'Session absente ou expirée.'
  if (status === 413) return detail || 'Image trop volumineuse.'
  if (status === 415) return detail || 'Format d’image non pris en charge.'
  if (status === 422) return detail || 'Structure de requête incompatible.'
  if (status === 502 || status === 503) {
    return detail || 'Service d’analyse indisponible. Vous pouvez saisir les infos.'
  }
  if (status === 405) {
    return detail || 'La route d’identification photo n’est pas disponible sur ce serveur.'
  }
  return detail || error?.message || 'Analyse impossible. Vous pouvez saisir les infos.'
}

export function isEmptyIdentification(analysis) {
  if (!analysis || typeof analysis !== 'object') return true
  return !['name_fr', 'suggestedName', 'translatedName', 'translated_name', 'nameEn', 'brand']
    .some((key) => String(analysis[key] || '').trim())
}
